import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("serabi_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("serabi_token");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export function apiErrorMessage(error) {
  const d = error?.response?.data;
  if (d?.message) return d.message;
  return error?.message || "Terjadi kesalahan. Coba lagi.";
}

// Generic helpers returning the standard envelope's data/pagination
export const api = {
  get: (url, params) => client.get(url, { params }).then((r) => r.data),
  post: (url, body) => client.post(url, body).then((r) => r.data),
  put: (url, body) => client.put(url, body).then((r) => r.data),
  del: (url) => client.delete(url).then((r) => r.data),
};

export default client;
